module.exports = __webpack_public_path__ + "static/media/landing1.3cef6e6f.svg";